
import { Component, Vue } from 'vue-property-decorator';
import { Modal, Button } from 'ant-design-vue';
import { namespace } from 'vuex-class';

interface PageAccess {
  status: number;
  info: string;
}

const HOW_UNFREEZE_TIPS: string[] = [
  '必须是营业执照/办学许可的法人本人的身份证复印件',
  '盖企业公章',
  '法人签字',
  '写上"供与北京爱学习博乐教育科技有限公司网上签约使用"',
  '您可以拨打爱学习电话：400-898-9909联系运营人员 帮助您提交身份证复印件',
];

const userModule = namespace('user');

@Component({
  components: {
    AModal: Modal,
    AButton: Button,
  },
})
export default class FreezeDialog extends Vue {
  @userModule.Getter('userInfo') userInfo: any;

  // 是否显示
  private visible: boolean = true;

  // 显示冻结提醒
  private showFreezeState: boolean = true;

  // 如何上传身份证
  private howUnfreezeTips: string[] = HOW_UNFREEZE_TIPS;

  private get pageAccess(): PageAccess {
    const { pageAccess } = this.userInfo;
    return pageAccess;
  }

  // 关闭弹框提醒
  private handleClose() {
    if (this.pageAccess.status === 3) {
      this.visible = false;
    } else {
      this.showFreezeState = true;
    }
  }
}
